import type { AvailabilitySlot } from "./api.js";

export interface BookingFailureView {
  status: "rejected" | "uncertain";
  message: string;
}

export interface BookingFailureRow {
  slot: AvailabilitySlot;
  failure: BookingFailureView;
}

export function partitionBookingFailureRows(rows: readonly BookingFailureRow[]): {
  rejected: BookingFailureRow[];
  uncertain: BookingFailureRow[];
} {
  return {
    rejected: rows.filter((row) => row.failure.status === "rejected"),
    uncertain: rows.filter((row) => row.failure.status === "uncertain"),
  };
}

/**
 * Replace any selected slot that is still present with the fresh availability
 * shape returned by FastAPI, while keeping missing rows around long enough to
 * explain/retry an uncertain outcome with its existing idempotency key.
 */
export function reconcileSelectedAvailability(
  selected: readonly AvailabilitySlot[],
  fresh: readonly AvailabilitySlot[],
): AvailabilitySlot[] {
  const byStart = new Map(fresh.map((slot) => [slot.starts_at, slot]));
  return selected.map((slot) => byStart.get(slot.starts_at) ?? slot);
}
